import React, {useMemo} from "react";
import styles from './Input.module.css'
import cx from "classnames";
import {Language} from "../../types/PluginData";
import MultiLanguageIcon from "../MultiLanguageIcon";

type InputProps = {
    type: 'text' | 'number' | 'password' | 'email' | 'textarea';
    placeholder: string;
    property: string
    value: string | number;
    onChange: (property: string, value: any) => void;
    classes?: string;
    disabled?: boolean;
    maxLength?: number;
    style?: React.CSSProperties;
    withCount?: boolean;
    multiLanguage?: boolean;
    multiLanguageValue?: string;
    onMultiLanguageChange?: (property: string, value: string) => void;
    min?: number;
    max?: number;
    step?: number
};

const Input: React.FC<InputProps> = (
    {
        type,
        placeholder,
        value,
        onChange,
        classes,
        disabled= false,
        property,
        style ,
        maxLength,
        withCount = false,
        multiLanguage = false,
        multiLanguageValue,
        onMultiLanguageChange,
        min,
        max,
        step
    }
) => {
    const inputChange = (event: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => {
        if (!maxLength || event.target.value.length <= maxLength) onChange(property, event.target.value)
    }

    const count = useMemo(() => {
        return (value + '').length
    }, [value])


    return (
        <div className={cx(styles['zr-input-container'], classes)} style={style}>
            {type !== 'textarea' ?
                <input
                    type={type}
                    value={value}
                    onChange={inputChange}
                    placeholder={placeholder}
                    className={cx(styles['zr-input'], value !== "" && styles['zr-input-filled'])}
                    disabled={disabled}
                    autoComplete={property}
                    min={min}
                    max={max}
                    step={step}
                />
                : <textarea
                    value={value}
                    onChange={inputChange}
                    placeholder={placeholder}
                    className={cx(styles['zr-input'], value !== "" && styles['zr-input-filled'])}
                    disabled={disabled}
                    maxLength={maxLength}
                    autoComplete={property}
                />
            }
            <label>
                {placeholder}
                {multiLanguage && (
                    <MultiLanguageIcon
                        property={property + '_multi'}
                        onMultiLanguageChange={onMultiLanguageChange}
                        multiLanguageValue={multiLanguageValue}
                    />
                )}
            </label>
            {withCount && <span className={cx(styles['zr-count'])}>{count}/{maxLength}</span>}
            <span className={cx(styles['focus-border'])}>
                <i/>
            </span>
        </div>

    );
};

export default Input;
